<template>
  <div class="login-container">
    <div class="header-section">
      <div class="logo-section">
        <img src="/favicon.ico" alt="Logo" class="logo-img">
        <div class="logo-text">
          <div class="logo-title">Doneist</div>
          <div class="logo-subtitle">开放平台</div>
        </div>
      </div>
    </div>
    <div class="main-section">
      <el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" label-position="left" label-width="0px" class="login-card">
        <div class="card-content">
          <div class="card-title">欢迎来到Doneist开放平台</div>
          <el-form-item prop="username">
            <el-input type="text" v-model="ruleForm.username" placeholder="用户名 / 邮箱 / 电话号码" auto-complete="off"
                      prefix-icon="el-icon-user" @keyup.native.enter="handleSubmit"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input show-password v-model="ruleForm.password" placeholder="密码" auto-complete="off"
                      prefix-icon="el-icon-lock" @keyup.native.enter="handleSubmit"></el-input>
          </el-form-item>
          <div class="form-options">
            <el-checkbox size="medium" v-model="checked" class="stay-logged-in">保持登录</el-checkbox>
            <el-link :underline="false" class="forget-pw" @click="resetPassword">忘记密码？</el-link>
          </div>
          <el-form-item style="width:100%;">
            <el-button type="primary" id="loginButton" style="width:100%;" @click="handleSubmit" :loading="loading">立即登录</el-button>
          </el-form-item>
        </div>
        <div class="card-footer">
          <router-link class="register-link" to="/register">没有Doneist账户？立即注册</router-link>
        </div>
      </el-form>
    </div>
    <div class="copyright">
      © 2026 Doneist Project. All rights reserved.
      <span class="separator">|</span>
      <el-link target="_blank" class="beian-link" :underline="false" href="https://beian.miit.gov.cn/">备案号：蜀ICP备19030913号-2</el-link>
    </div>
  </div>
</template>

<script>
import router from "@/router"
require('@/assets/geetest4')
export default {
  data() {
    return {
      loading: false,
      ruleForm: {},
      rules: {
        username: [{
          required: true,
          message: '请输入用户名 / 邮箱 / 电话号码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      checked: false
    }
  },
  created() {
    console.log("亲爱的小伙伴们，你们好呀，这是一个彩蛋，只有点进这个页面的小伙伴才能看到，很高兴认识你们，祝你们每天都开心愉快，充满好运😊🎉🌙")
  },
  mounted() {
    this.initGeeTest();
  },
  methods: {
    resetPassword(){
      router.push('/resetPassword')
    },
    initGeeTest() {
      let _this = this;
      window.initGeetest4({
        captchaId: '3852403296691657cab0591c806db96',
        product: 'bind',
        protocol: "https://"
      }, function (captcha) {
        window.captcha = captcha;
        captcha.onReady(function () {
        }).onSuccess(function () {
          let result = window.captcha.getValidate();
          let data = _this.ruleForm;
          data['lotNumber'] = result.lot_number;
          data['captchaOutput'] = result.captcha_output;
          data['passToken'] = result.pass_token;
          data['genTime'] = result.gen_time;
          data['remembered'] = _this.checked;
          _this.$store.dispatch('user/login', data).then(()=> {
            router.push('/').then(()=> {})
            _this.loading = false;
          }).catch(()=> {
            _this.loading = false;
          })
        }).onError(function () {
          _this.loading = false;
        }).onClose(function () {
          _this.loading = false;
        });
      });
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          window.captcha.showCaptcha();
          this.loading = true;
        } else {
          this.$message.error("登录校验未通过，请核对！")
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 30%, #f093fb 60%, #4facfe 100%);
  background-attachment: fixed;
}

.header-section {
  padding: 32px 48px;
  flex-shrink: 0;
}

.logo-section {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 48px;
  height: 48px;
  margin-right: 16px;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.logo-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
}

.logo-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
}

.main-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 3vh;
  padding-bottom: 32px;
}

@media screen and (min-height: 800px) {
  .main-section {
    padding-top: 10vh;
  }
}

.login-card {
  width: 400px;
  height: 480px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(30px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.card-content {
  flex: 1;
}

.card-footer {
  margin-top: auto;
  padding-top: 10px;
}

.card-title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 32px;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.stay-logged-in {
  font-size: 14px;
  color: #64748b;
}

.forget-pw {
  font-size: 14px;
  color: #667eea;
}

.register-link {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}

#loginButton {
  font-weight: 600;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

#loginButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
}

.copyright {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  padding: 24px 16px;
  flex-shrink: 0;
}

.separator {
  margin: 0 12px;
}

.beian-link {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

@media screen and (max-width: 768px) {
  .header-section {
    padding: 20px 24px;
  }

  .logo-img {
    width: 40px;
    height: 40px;
  }

  .login-card {
    width: 100%;
    max-width: 360px;
    padding: 32px 24px;
  }

  .card-title {
    font-size: 20px;
  }

  .copyright {
    font-size: 12px;
  }


}
</style>
